"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MetaHierarchy = void 0;
/**
 * Restricts values of the user-action event metaHierarchy items on the Order summary component level.
 */ let MetaHierarchy = exports.MetaHierarchy = /*#__PURE__*/ function(MetaHierarchy) {
    /** User clicked the login button in checkout summary section. */ MetaHierarchy["Login"] = "checkout_login";
    /** User clicked the Bonus Points / Wallet button in checkout summary section. */ MetaHierarchy["SelectAccountBalance"] = "checkout_account_balance_select";
    /** The specified voucher code was successfully applied. */ MetaHierarchy["VoucherApplied"] = "checkout_voucher_apply";
    return MetaHierarchy;
}({});
